export default __webpack_public_path__ + "static/media/logo_banner_nomina.304dddd1.png";